import { render, staticRenderFns } from "./signup-details.vue?vue&type=template&id=a128ee06&"
import script from "./signup-details.vue?vue&type=script&lang=js&"
export * from "./signup-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports